const PALETTE = ["#2362B4", "#E15554", "#F2A93B", "#3BA55D", "#8E5FD8"];

// Picks a consistent color for a category string: hashes the characters
// (Java-style hash = hash*31 + charCode, done via bit-shift) into a number,
// then mods it by PALETTE.length so the same category always maps to the same color.
export const getNotificationColor = (category) => {
  if (!category) return PALETTE[0];
  let hash = 0;
  for (let i = 0; i < category.length; i++) {
    hash = category.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
};

// Inserts a space wherever a lowercase letter is followed by an uppercase letter,
// so PascalCase like "WorkOrderAssigned" reads as "Work Order Assigned".
export const humanizeCategory = (category) => {
  if (!category) return "";
  return category.replace(/([a-z])([A-Z])/g, "$1 $2");
};
